module.exports = ["บิดา","มารดา","ภรรยา ( กรณีไม่ได้จดทะเบียนสมรส )","สามี (ไม่ได้จดทะเบียนสมรส)","คู่สมรส  *( กรณีจดทะเบียนสมรส )","บุตร คนที่1","บุตร คนที่2","บุตร คนที่3","พี่สาว / น้องสาว","พี่สาว / น้องสาว คน 2","พี่สาว / น้องสาว คน 3","พี่สาว / น้องสาว คน 4","พี่สาว / น้องสาว คน 5","พี่ชาย / น้องชาย","พี่ชาย / น้องชาย คนที่ 2","พี่ชาย / น้องชาย คนที่ 3","พี่ชาย / น้องชาย คนที่ 4","พี่ชาย / น้องชาย คนที่ 5"]


//////////////////
// WEBPACK FOOTER
// ./src/assets/master/FamilyStatus/familyStatusTH.json
// module id = OSCT
// module chunks = 2